<template>
  <div class="step-contanier">
    <div class="view scrollbar">
      <div
        class="row"
        style="margin-left: 30px; justify-content: space-between"
      >
        <div>
          <el-radio-group v-model="billType" @input="form1.transportName = ''">
            <el-radio-button
              v-for="item in billTypeItem"
              :key="item.id"
              :label="item.id"
            >{{ item.name }}</el-radio-button
            >
          </el-radio-group>
          <span class="transportName">{{ form1.transportName }}</span>
        </div>
      </div>
      <BasePanel height="40px" style="margin-top: 10px" title="提单信息">
        <div class="content">
          <el-form
            ref="billInfo"
            :model="form1"
            :rules="rules1"
            label-position="top"
          >
            <el-row class="row" :gutter="20">
              <el-col :span="4">
                <el-form-item prop="mblNo" label="主单号">
                  <el-input
                    v-model="form1.mblNo"
                    style="width: 100%"
                    size="small"
                    placeholder="请输入主单号"
                    @blur="changeMblNo"
                    @input="onInput('mblNo')"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="blNo" label="分单号">
                  <el-input
                    v-model="form1.blNo"
                    size="small"
                    style="width: 100%"
                    placeholder="请输入分单号"
                    @blur="changeMblNo"
                    @input="onInput('blNo')"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="date" label="ETD - ETA">
                  <el-date-picker
                    v-model="form1.date"
                    type="daterange"
                    unlink-panels
                    size="small"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    start-placeholder="请选择日期"
                    end-placeholder="请选择日期"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="dischargeHarborDate" label="到卸货港日期">
                  <el-date-picker
                    v-model="form1.dischargeHarborDate"
                    size="small"
                    type="datetime"
                    placeholder="请选择到卸货港日期"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="countryCode" label="目的国家">
                  <el-select
                    v-model="form1.countryCode"
                    filterable
                    style="width: 100%"
                    size="small"
                    placeholder="请选择目的国家"
                    @change="form1.destinationHarborName = ''"
                  >
                    <el-option
                      v-for="(item, index) in addressDropCodeOption"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="companyId" label="客户">
                  <el-select
                    v-model="form1.companyId"
                    filterable
                    style="width: 100%"
                    size="small"
                    placeholder="请选择客户"
                  >
                    <el-option
                      v-for="(item, $index) in companyDrapdown"
                      :key="$index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="row">
              <el-col :span="4">
                <el-form-item prop="originHarborName" label="始发港">
                  <el-select
                    v-model="form1.originHarborName"
                    size="small"
                    filterable
                    style="width: 100%"
                    placeholder="请选择始发港"
                  >
                    <el-option
                      v-for="(item, $index) in orginPortOptions"
                      :key="$index"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="destinationHarborName" label="目的港">
                  <el-select
                    v-model="form1.destinationHarborName"
                    filterable
                    size="small"
                    style="width: 100%"
                    placeholder="请选择目的港"
                  >
                    <el-option
                      v-for="(item, $index) in destinPortOptions"
                      :key="$index"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select> </el-form-item
                ></el-col>
              <el-col :span="4">
                <el-form-item prop="dischargeHarbor" label="卸货港">
                  <el-select
                    v-model="form1.dischargeHarbor"
                    filterable
                    size="small"
                    style="width: 100%"
                    placeholder="请选择目的港"
                  >
                    <el-option
                      v-for="(item, $index) in destinPortOptions"
                      :key="$index"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select> </el-form-item
                ></el-col>
              <template v-if="billType">
                <el-col :span="4">
                  <el-form-item prop="qty" label="提单件数(件)">
                    <el-input
                      v-model="form1.qty"
                      style="width: 100%"
                      size="small"
                      placeholder="请输入提单件数"
                      @input="onInput('qty')"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="weightCbm" label="方数(CBM)">
                    <el-input
                      v-model="form1.weightCbm"
                      style="width: 100%"
                      size="small"
                      placeholder="请输入方数"
                      @input="onInput('weightCbm')"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="weightKgs" label="重量(KG)">
                    <el-input
                      v-model="form1.weightKgs"
                      size="small"
                      style="width: 100%"
                      placeholder="请输入重量"
                      @input="onInput('weightKgs')"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </template>
              <template v-else>
                <el-col :span="4">
                  <el-form-item prop="originCountry" label="原产国">
                    <el-select
                      v-model="form1.originCountry"
                      filterable
                      disabled
                      style="width: 100%"
                      size="small"
                      placeholder="请选择原产国"
                    >
                      <el-option
                        v-for="(item, index) in addressDropCodeOption"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
            <el-row v-if="billType" :gutter="20">
              <el-col :span="4">
                <el-form-item prop="originCountry" label="原产国">
                  <el-select
                    v-model="form1.originCountry"
                    filterable
                    disabled
                    style="width: 100%"
                    size="small"
                    placeholder="请选择原产国"
                  >
                    <el-option
                      v-for="(item, index) in addressDropCodeOption"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="row">
              <el-col :span="8">
                <el-form-item prop="consigneeName" style="width: 100%">
                  <div slot="label" class="form-item_label">
                    <span>收货人/Consignee</span>
                    <div>
                      <span class="add" @click="add(20)">
                        <svg-icon iconClass="add" className="icon" />添加</span
                      >
                    </div>
                  </div>
                  <el-select
                    v-model="form1.consigneeName"
                    style="width: 100%"
                    filterable
                    clearable
                    placeholder="请选择"
                    @change="changeConsignee"
                  >
                    <el-option
                      v-for="(item, index) in consigneeOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    >
                      <span style="float: left">{{ item.label }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                      >
                        {{ item?.address | formatStatusAddress }}
                        {{ item?.cityAddress | formatStatusAddress }}
                        {{ item?.provinceEnName | formatStatusAddress }}
                        {{ item?.countryName | formatStatusAddress }}
                        <strong>{{
                          item?.postcode ? item?.postcode : ""
                        }}</strong>
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="shipperName" style="width: 100%">
                  <div slot="label" class="form-item_label">
                    <span>发货人/Shipper</span>
                    <span class="add" @click="add(20)">
                      <svg-icon iconClass="add" className="icon" />添加</span
                    >
                  </div>
                  <el-select
                    v-model="form1.shipperName"
                    style="width: 100%"
                    filterable
                    clearable
                    placeholder="请选择"
                    @change="changeShipper"
                  >
                    <el-option
                      v-for="(item, index) in shipperOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    >
                      <span style="float: left">{{ item.label }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                      >
                        {{ item?.address | formatStatusAddress }}
                        {{ item?.cityAddress | formatStatusAddress }}
                        {{ item?.provinceEnName | formatStatusAddress }}
                        {{ item?.countryName | formatStatusAddress }}
                        <strong>{{
                          item?.postcode ? item?.postcode : ""
                        }}</strong>
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="notifyPartyName" style="width: 100%">
                  <div slot="label" class="form-item_label">
                    <span>通知方/Notify party</span>
                    <span class="add" @click="add(20)">
                      <svg-icon iconClass="add" className="icon" />添加</span
                    >
                  </div>
                  <el-select
                    v-model="form1.notifyPartyName"
                    style="width: 100%"
                    filterable
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in notifyPartyOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    >
                      <span style="float: left">{{ item.label }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                      >
                        {{ item?.address | formatStatusAddress }}
                        {{ item?.cityAddress | formatStatusAddress }}
                        {{ item?.provinceEnName | formatStatusAddress }}
                        {{ item?.countryName | formatStatusAddress }}
                        <strong>{{
                          item?.postcode ? item?.postcode : ""
                        }}</strong>
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="row">
              <el-col :span="8">
                <el-form-item prop="manufacturerName" style="width: 100%">
                  <div slot="label" class="form-item_label">
                    <span>制造商/Manufacturer</span>
                    <div>
                      <span class="add" @click="add(20)">
                        <svg-icon iconClass="add" className="icon" />添加</span
                        >
                      <span style="margin-left: 10px;">
                        <el-switch
                          v-model="isSameShipper"
                          active-text="同发货人">
                        </el-switch>
                      </span>
                    </div>
                  </div>
                  <el-select
                    v-model="form1.manufacturerName"
                    style="width: 100%"
                    filterable
                    clearable
                    placeholder="请选择"
                    @change="manufacturerNameChange"
                  >
                    <el-option
                      v-for="(item, index) in manufacturerOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    >
                      <span style="float: left">{{ item.label }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                      >
                        {{ item?.address | formatStatusAddress }}
                        {{ item?.cityAddress | formatStatusAddress }}
                        {{ item?.provinceEnName | formatStatusAddress }}
                        {{ item?.countryName | formatStatusAddress }}
                        <strong>{{
                          item?.postcode ? item?.postcode : ""
                        }}</strong>
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="importerName" style="width: 100%">
                  <div slot="label" class="form-item_label">
                    <span>进口商/Importer</span>
                    <span style="margin-left: 10px;">
                      <el-switch
                        v-model="isSameConsignee"
                        active-text="同收货人">
                      </el-switch>
                    </span>
                  </div>
                  <el-select
                    v-model="form1.importerName"
                    style="width: 100%"
                    filterable
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in importerList"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    >
                      <span style="float: left">{{ item.name }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                      >
                        {{ item?.address | formatStatusAddress }}
                        {{ item?.cityAddress | formatStatusAddress }}
                        {{ item?.provinceEnName | formatStatusAddress }}
                        {{ item?.countryName | formatStatusAddress }}
                        <strong>{{
                          item?.postcode ? item?.postcode : ""
                        }}</strong>
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="ultimateConsigneeName" style="width: 100%">
                  <div slot="label" class="form-item_label">
                    <span>最终收货人/Ultimate Consignee</span>    <div>
                      <span class="add" @click="add(20)">
                        <svg-icon iconClass="add" className="icon" />添加</span
                        >
                      <span style="margin-left: 10px;">
                        <el-switch
                          v-model="isSameConsigneeToUltimateConsignee"
                          active-text="同收货人">
                        </el-switch>
                      </span>
                    </div>
                  </div>
                  <el-select
                    v-model="form1.ultimateConsigneeName"
                    style="width: 100%"
                    filterable
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in ultimateConsigneeOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    >
                      <span style="float: left">{{ item.label }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                      >
                        {{ item?.address | formatStatusAddress }}
                        {{ item?.cityAddress | formatStatusAddress }}
                        {{ item?.provinceEnName | formatStatusAddress }}
                        {{ item?.countryName | formatStatusAddress }}
                        <strong>{{
                          item?.postcode ? item?.postcode : ""
                        }}</strong>
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </BasePanel>
      <BasePanel
        v-if="!billType"
        height="40px"
        style="margin-top: 12px"
        title="柜子信息"
      >
        <div slot="opt" class="panel-opt">
          <div class="add flex_c_c" @click="addCabinet">
            <svg-icon className="icon" iconClass="add" />
            新增柜子
          </div>
        </div>
        <div class="content">
          <div
            v-for="(item, $index) in form2Data"
            :key="$index"
            class="cabinet-item"
          >
            <img
              v-if="form2Data.length !== 1"
              src="@/assets/images/bill/delete-cabinet.png"
              class="delete-cabinet"
              @click="deleteCabinet($index)"
            />
            <el-form
              :ref="`containerInfo${$index}`"
              :model="item"
              :rules="rules2"
              label-position="top"
            >
              <el-form-item label="柜号" prop="containerNumber">
                <el-input
                  v-model="item.containerNumber"
                  placeholder="仅限输入数字和英文字符"
                  style="width: 260px"
                  size="small"
                  :maxlength="11"
                  oninput="value=value.replace(/[^0-9a-zA-Z]/g, '')"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="柜型" prop="containertype">
                <el-select
                  v-model="item.containertype"
                  filterable
                  style="width: 150px"
                  size="small"
                  placeholder="请选择柜型"
                >
                  <el-option
                    v-for="(op, opi) in config.containertypeOptions"
                    :key="opi"
                    :label="op.label"
                    :value="op.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item prop="vesselName" label="船名">
                <el-select
                  v-model="item.vesselName"
                  style="width: 150px"
                  filterable
                  size="small"
                  allow-create
                  placeholder="请选择船名"
                  default-first-option
                  @blur="onTypeBlur($event)"
                >
                  <el-option
                    v-for="vesselName in vesselNameOptions"
                    :key="vesselName.value"
                    :label="vesselName.label"
                    :value="vesselName.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="voyageNo" label="船次/航次">
                <el-input
                  v-model="item.voyageNo"
                  size="small"
                  style="width: 150px"
                  placeholder="请输入船次/航次"
                  @input="onInput('voyageNo')"
                />
              </el-form-item>
              <el-form-item prop="qty" label="提单件数(件)">
                <el-input
                  v-model="item.qty"
                  style="width: 100%"
                  size="small"
                  placeholder="请输入提单件数"
                  @input="onInput('qty')"
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="weightCbm" label="方数(CBM)">
                <el-input
                  v-model="item.weightCbm"
                  style="width: 100%"
                  size="small"
                  placeholder="请输入方数"
                  @input="onInput('weightCbm')"
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="weightKgs" label="重量(KG)">
                <el-input
                  v-model="item.weightKgs"
                  size="small"
                  style="width: 100%"
                  placeholder="请输入重量"
                  @input="onInput('weightKgs')"
                >
                </el-input>
              </el-form-item>
              <!-- <template v-if="form1.code === 'MATS'">
                <el-form-item prop="routeLine" label="航线">
                  <el-select
                    v-model="item.routeLine"
                    style="width: 100%"
                    size="small"
                    placeholder="请选择航线"
                  >
                    <el-option
                      v-for="routeLine in routeLineOptions"
                      :key="routeLine.value"
                      :label="routeLine.label"
                      :value="routeLine.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-else :span="4"> -->
              <el-form-item prop="routeLine2" label="航线">
                <el-input
                  v-model="item.routeLine"
                  style="width: 100%"
                  size="small"
                  placeholder="请输入"
                  @input="onInput('routeLine')"
                />
              </el-form-item>
              <!-- </template> -->
              <el-form-item label="封条号" prop="sealNumber">
                <el-input
                  v-model="item.sealNumber"
                  size="small"
                  placeholder="请输入封条号"
                  style="width: 160px"
                >
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </BasePanel>
      <div class="bill-detail">
        <el-form
          ref="billDetailInfo"
          style="width: calc(100% - 64px)"
          :model="form3"
          :rules="rules3"
          label-position="top"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <BasePanel
                height="40px"
                style="margin-top: 10px"
                title="清关方式"
              >
                <div v-if="!billType" slot="opt" class="panel-opt">
                  <div
                    v-if="form3.clearenceType === 1 && form3.isDeclareISF"
                    class="add flex_c_c"
                    @click="
                      drawer = true;
                      isShowIsf = true;
                    "
                  >
                    <!-- <svg-icon className="icon" iconClass="add" /> -->
                    <i
                      :class="
                        !isf
                          ? 'el-icon-warning-outline'
                          : 'el-icon-circle-check'
                      "
                    />
                    {{ !isf ? "未填写ISF" : "已填写ISF" }}
                  </div>
                </div>
                <div class="content">
                  <el-radio-group v-model="form3.clearenceType">
                    <el-radio-button
                      v-for="item in tabItems1"
                      :key="item.id"
                      :label="item.id"
                    >{{ item.name }}</el-radio-button
                    >
                  </el-radio-group>
                  <el-switch
                    v-model="form3.isDeclareISF"
                    style="margin-left: 12px"
                    active-color="#13ce66"
                    active-text="是否申报ISF"
                    inactive-color="#ff4949">
                  </el-switch>
                  <!-- <el-radio-group style="margin-left: 12px" v-model="form3.clearenceType">
                    <el-radio
                      v-for="item in tabItems1"
                      :key="item.id"
                      :label="item.id"
                    >{{ item.name }}</el-radio
                    >
                  </el-radio-group> -->
                  <template v-if="form3.clearenceType === 1">
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item
                          prop="receivedDoEmail"
                          label="接收DO邮箱（可多条输入）"
                        >
                          <el-input
                            v-model="form3.receivedDoEmail"
                            placeholder="接收DO邮箱（可多条输入）以,隔开"
                            style="width: 360px"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          prop="receivedDoCompany"
                          label="接收DO公司名称"
                        >
                          <el-input
                            v-model="form3.receivedDoCompany"
                            style="width: 360px"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item prop="clearanceMode" label="清关模式">
                          <el-select
                            v-model="form3.clearanceMode"
                            clearable
                            style="width: 360px"
                            placeholder="请选择清关模式"
                          >
                            <el-option
                              v-for="item in config.clearanceModesOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </template>
                </div>
              </BasePanel>
            </el-col>
            <el-col :span="12">
              <BasePanel
                height="40px"
                style="margin-top: 10px"
                title="提货方式"
              >
                <div class="content">
                  <!-- <RadioTab
                    v-model="form3.pickUpType"
                    :tabItems="tabItems2"
                    @tabChange="(v) => tabChange(v, 1)"
                  ></RadioTab> -->
                  <el-radio-group v-model="form3.pickUpType">
                    <el-radio-button
                      v-for="item in tabItems2"
                      :key="item.id"
                      :label="item.id"
                    >{{ item.name }}</el-radio-button
                    >
                  </el-radio-group>
                  <template v-if="form3.pickUpType === 1">
                    <div class="row" style="margin-top: 14px">
                      <div class="field">
                        <label
                        ><span class="require">* </span>选择直送类型</label
                        >
                        <el-radio-group
                          v-model="form3.deliveryType"
                          @input="form3.code = ''"
                        >
                          <el-radio
                            style="margin-left: 10px"
                            :label="2"
                          >私仓</el-radio
                          >
                          <el-radio :label="1">亚马逊仓</el-radio>
                          <el-radio :label="0">快递商</el-radio>
                          <el-radio :label="5">沃尔玛仓</el-radio>
                        </el-radio-group>
                      </div>
                    </div>
                    <template v-if="form3.deliveryType">
                      <div class="row" style="width: 100%">
                        <el-form-item prop="code" style="width: 100%">
                          <div slot="label" class="form-item_label">
                            <span>选择仓库</span>
                            <span
                              v-if="form3.deliveryType === 2"
                              class="add"
                              @click="add(0)"
                            >
                              <svg-icon
                                iconClass="add"
                                className="icon"
                              />新增</span
                            >
                          </div>
                          <!-- <div class="customSelect" style="width: 517px">
                            <custom-select
                              v-model="form3.code"
                              :value="form3.code"
                              :selectItems="warehouseList"
                              :dropdownWidth="517"
                              placeholder="请选择仓库"
                              label="仓库编码"
                            ></custom-select>
                          </div> -->
                          <el-select
                            v-model="form3.code"
                            style="width: 100%"
                            filterable
                            clearable
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in warehouseList"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label"
                            >
                              <span style="float: left">{{ item.label }}</span>
                              <span
                                style="
                                  float: right;
                                  color: #8492a6;
                                  font-size: 13px;
                                "
                              >
                                {{ item?.address | formatStatusAddress }}
                                {{ item?.city | formatStatusAddress }}
                                {{ item?.provinceEnName | formatStatusAddress }}
                                {{ item?.countryName | formatStatusAddress }}
                                <strong>{{
                                  item?.postcode ? item?.postcode : ""
                                }}</strong>
                              </span>
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </template>
                    <div v-if="form3.deliveryType === 0" class="row">
                      <el-form-item prop="expressSupplier" label="选择快递商">
                        <div class="supplyList">
                          <div
                            v-for="(
                              item, $index
                            ) in config.expressSupplierOptions"
                            :key="item.value"
                            class="item"
                            :class="{ active: kdSupplyIndex === $index }"
                            @click="kdSupplyIndex = $index"
                          >
                            <img
                              :src="require(`@/assets/images/serverSupply/${item.value.toLowerCase()}.png`)"
                              class="logoUrl"
                            />
                          </div>
                        </div>
                      </el-form-item>
                    </div>
                  </template>
                </div>
              </BasePanel>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="pageBtn">
      <el-button
        type="text"
        style="position: absolute; left: 20px"
        @click="download"
      >
        <svg-icon iconClass="download" className="icon" />
        下载预报模板
      </el-button>
      <div class="btn btn-defalut flex_c_c" @click="resetFields">重置</div>
      <div class="btn btn-primary flex_c_c" @click="nextStep">确定</div>
    </div>
    <warehouseadd-dialog
      :isSelectType="false"
      :dialogVisible="dialogVisible"
      :activeName="warehouseType.toString()"
      @ok="ok"
      @cancel="dialogVisible = false"
    ></warehouseadd-dialog>
    <ISFDrawer
      v-if="drawer"
      :drawer="drawer"
      :scinList="scinList"
      :importerList="importerList"
      :companyId="form1.companyId"
      :shipperName="form1.shipperName"
      :billType="billType"
      :consigneeName="form1.consigneeName"
      :importerName="form1.importerName"
      :notifyPartyName="form1.notifyPartyName"
      :manufacturerName="form1.manufacturerName"
      :ultimateConsigneeName="form1.ultimateConsigneeName"
      :blNo="form1.blNo || form1.mblNo"
      :masterType="form1.blNo ? 1 : 0"
      :etd="form1.date[0]"
      :editISF="isf || {}"
      @ok="ok1"
      @close="(drawer = false), (isShowIsf = true)"
    ></ISFDrawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const BasePanel = () => import('@/components/panel/BasePanelForm1.vue')
const WarehouseaddDialog = () =>
  import('@/components/dialog/WarehouseAddDialog.vue')
// const RadioTab = () => import('@/components/tab/RadioTab.vue')
// import CustomSelect from './components/CustomSelect2'
import ISFDrawer from './components/ISFDrawer'
import { debounce, insertStr } from '@/utils/common'
import { existsMBL, createMbl } from '@/api/bill'
import { getVesselNameList, getScinList } from '@/api/basic'
import { getImporterDrapdown } from '@/api/system'
import config from '@/utils/config'
export default {
  components: {
    BasePanel,
    // CustomSelect,
    WarehouseaddDialog,
    // RadioTab,
    ISFDrawer
  },
  filters: {
    formatStatusAddress(val) {
      return val ? val + ',' : ''
    }
  },
  props: {},
  data() {
    const validateMblNo = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入主单号'))
      } else {
        if (this.billType && value.length !== 12) {
          callback(new Error('主单号格式有误'))
        } else {
          this.checkMblNo(value, callback)
        }
      }
    }
    const validateTransportName = (rule, value, callback) => {
      if (!value) {
        callback(new Error(`请选择${!this.billType ? '船' : '航'}公司`))
      } else {
        callback()
      }
    }
    const validateContainerNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入柜号'))
      } else {
        if (value.length < 8) {
          callback(new Error('柜号长度必须大于8位'))
        } else {
          callback()
        }
      }
    }
    return {
      config,
      billType: 0,
      drawer: false,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      form1: {
        transportName: '',
        transitSupplierId: '',
        mblNo: '',
        blNo: '',
        countryCode: 'US',
        originCountry: '',
        originHarborName: '',
        destinationHarborName: '',
        dischargeHarborDate: '',
        dischargeHarbor: '',
        date: [],
        shipperName: '',
        consigneeName: '',
        importerName: '',
        notifyPartyName: '',
        manufacturerName: '',
        ultimateConsigneeName: '',
        companyId: '',
        // sellerName: '',
        // manufactureName: '',
        // consolidatorName: '',
        // staffingLocationName: '',
        // shipToPartyName: '',
        routeLine: '',
        vesselName: '',
        voyageNo: '',
        qty: '',
        weightKgs: '',
        weightCbm: ''
      },
      rules1: {
        mblNo: [{ required: true, validator: validateMblNo, trigger: 'blur' }],
        transportName: [
          {
            required: true,
            validator: validateTransportName,
            trigger: 'change'
          }
        ],
        transitSupplierId: [
          { required: true, message: '请选择订仓代理', trigger: 'change' }
        ],
        companyId: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        countryCode: [
          { required: true, message: '请选择目的国', trigger: 'change' }
        ],
        originCountry: [
          { required: true, message: '请选择原产国', trigger: 'change' }
        ],
        originHarborName: [
          { required: true, message: '请选择始发港', trigger: 'change' }
        ],
        destinationHarborName: [
          { required: true, message: '请选择目的港', trigger: 'change' }
        ],
        date: [{ required: true, message: '请选择ETD-ETA', trigger: 'change' }],
        qty: [{ required: true, message: '请输入提单件数', trigger: 'blur' }],
        weightKgs: [{ required: true, message: '请输入重量', trigger: 'blur' }],
        weightCbm: [{ required: true, message: '请输入方数', trigger: 'blur' }],
        shipperName: [
          { required: true, message: '请选择发货人', trigger: 'change' }
        ],
        consigneeName: [
          { required: true, message: '请选择收货人', trigger: 'change' }
        ],
        importerName: [
          { required: true, message: '请选择进口商', trigger: 'change' }
        ],
        notifyPartyName: [
          { required: true, message: '请选择通知方', trigger: 'change' }
        ],
        manufacturerName: [
          { required: true, message: '请选择制造商', trigger: 'change' }
        ],
        ultimateConsigneeName: [
          { required: true, message: '请选择最终收货人', trigger: 'change' }
        ]
      },
      form2Data: [
        {
          containerNumber: '',
          containertype: '20GP',
          sealNumber: '',
          routeLine: '',
          voyageNo: '',
          vesselName: ''
        }
      ],
      rules2: {
        containerNumber: [
          {
            required: true,
            validator: validateContainerNumber,
            trigger: 'blur'
          }
        ],
        containertype: [
          { required: true, message: '请选择柜型', trigger: 'change' }
        ],
        vesselName: [
          { required: true, message: '请选择船名', trigger: 'change' }
        ],
        qty: [{ required: true, message: '请输入提单件数', trigger: 'blur' }],
        weightKgs: [{ required: true, message: '请输入重量', trigger: 'blur' }],
        weightCbm: [{ required: true, message: '请输入方数', trigger: 'blur' }],
        // routeLine: [
        //   { required: true, message: '请选择航线', trigger: 'change' }
        // ],
        voyageNo: [
          { required: true, message: '请选择船次/航次', trigger: 'change' }
        ]
      },
      form3: {
        clearenceType: 1,
        pickUpType: 0,
        deliveryType: 1,
        code: '',
        deliveryDemand: '',
        expressSupplier: '',
        clearanceMode: 1,
        isDeclareISF: true
      },
      rules3: {
        clearenceType: [{ required: true }],
        pickUpType: [{ required: true }],
        receivedDoEmail: [
          {
            required: true,
            message: '请输入接收DO邮箱（可多条输入）',
            trigger: 'blur'
          }
        ],
        receivedDoCompany: [
          { required: true, message: '请输入接收DO公司名称', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请选择仓库', trigger: 'change' }],
        clearanceMode: [{ required: true, message: '请选择清关模式', trigger: 'change' }]
      },
      dialogVisible: false,
      dialogVisible1: false,
      warehouseType: 2,
      routeLineOptions: [
        {
          value: 'CLX',
          label: 'CLX'
        },
        {
          value: 'CLX+',
          label: 'CLX+'
        },
        {
          value: 'CCX',
          label: 'CCX'
        }
      ],
      vesselNameOptions: [],
      transitSupplierOptions: [],
      billTypeItem: [
        {
          name: '海运',
          id: 0
        },
        {
          name: '空运',
          id: 1
        }
      ],
      tabItems1: [
        {
          name: '自清',
          id: 0
        },
        {
          name: '平台清',
          id: 1
        }
      ],
      tabItems2: [
        {
          name: '自提',
          id: 0
        },
        {
          name: '直送',
          id: 1
        },
        {
          name: '回仓',
          id: 2
        }
      ],
      kdSupplyIndex: 0,
      fileList: [],
      mblFile: null,
      isf: null,
      isShowIsf: false,
      scinList: [],
      importerList: [],
      isSameConsignee: true,
      isSameShipper: true,
      isSameConsigneeToUltimateConsignee: true
    }
  },
  computed: {
    ...mapGetters([
      'addressDropOption',
      'shipTransportOptions',
      'airTransportOptions',
      'shipOrginPortOptions',
      'airOrginPortOptions',
      'airDestinPortOptions',
      'shipDestinPortOptions',
      'addressBookOptions',
      'companyDrapdown'
    ]),
    transportOptions() {
      return this.billType
        ? this.airTransportOptions
        : this.shipTransportOptions
    },
    addressDropCodeOption() {
      return this.addressDropOption.map((item) => {
        return {
          value: item.regionCode,
          label: `${item.label}`,
          id: item.value
        }
      })
    },
    orginPortOptions() {
      return this.billType
        ? this.airOrginPortOptions
        : this.shipOrginPortOptions
    },
    destinPortOptions() {
      const portOptions = this.billType
        ? this.airDestinPortOptions
        : this.shipDestinPortOptions
      const arr = portOptions.filter((a) => a.code === this.form1.countryCode)
      return arr
    },
    shipperOptions() {
      console.log(this.scinList)
      return this.scinList
        ?.filter((a) => a.type.indexOf(0) > -1)
        .map((item) => {
          item.label = item.name
          return item
        })
    },
    consigneeOptions() {
      console.log(this.scinList)
      return this.scinList
        ?.filter((a) => a.type.indexOf(1) > -1)
        .map((item) => {
          item.label = item.name
          return item
        })
    },
    notifyPartyOptions() {
      return this.scinList
        ?.filter((a) => a.type.indexOf(3) > -1)
        .map((item) => {
          item.label = item.name
          return item
        })
    },
    manufacturerOptions() {
      return this.scinList
        ?.filter((a) => a.type.indexOf(4) > -1)
        .map((item) => {
          item.label = item.name
          return item
        })
    },
    ultimateConsigneeOptions() {
      return this.scinList
        ?.filter((a) => a.type.indexOf(5) > -1)
        .map((item) => {
          item.label = item.name
          return item
        })
    },
    // 亚马逊仓
    AMZWarehouseList() {
      return (
        this.addressBookOptions[this.form1.companyId] ||
        this.addressBookOptions[0]
      )
        .filter((a) => a.type === 1)
        .map((item) => {
          item.label = `${item.code}`
          return item
        })
    },
    // 沃尔玛仓
    WrmWarehouseList() {
      return (
        this.addressBookOptions[this.form1.companyId] ||
        this.addressBookOptions[0]
      )
        .filter((a) => a.type === 100)
        .map((item) => {
          item.label = `${item.code}`
          return item
        })
    },
    warehouseList() {
      const companyWarehouseList = (
        this.addressBookOptions[this.form1.companyId] ||
        this.addressBookOptions[0]
      ).filter((a) => a.type === 0 && a.companyId === this.form1.companyId)
      const arr = companyWarehouseList.map((item) => {
        item.label = `${item.code}`
        return item
      })
      if (this.form3.deliveryType === 1) {
        return this.AMZWarehouseList
      } else if (this.form3.deliveryType === 5) {
        return this.WrmWarehouseList
      } else {
        return arr
      }
      // return this.form3.deliveryType === 1 ? this.AMZWarehouseList : arr
    }
  },
  watch: {
    stageObj: {
      handler(stageObj) {
        if (stageObj && stageObj.stepOneSave.mblNo) {
          const data = stageObj.stepOneSave
          this.form1 = {
            mblNo: data.mblNo,
            transitSupplierId: data.transitSupplierId,
            blNo: data.blNo,
            code: data.mblNo.slice(0, 4),
            countryCode: data.countryCode,
            originCountry: data.originCountry,
            transportName: data.transportName,
            companyId: data.companyId,
            routeLine: data.routeLine,
            vesselName: data.vesselName,
            voyageNo: data.voyageNo,
            shipperName: data.shipperName,
            consigneeName: data.consigneeName,
            destinationHarborName: data.destinationHarborName,
            originHarborName: data.originHarborName,
            date: data.date,
            qty: data.type ? data.qty : '',
            weightKgs: data.type ? data.weightKgs : '',
            weightCbm: data.type ? data.weightCbm : ''
          }
          if (!data.type) {
            this.form2Data = data.containers
          }
          const warehouse = this.warehouseList.find(
            (a) => a.code === data.code,
          )
          this.form3 = {
            clearenceType: data.clearenceType,
            pickUpType: data.pickUpType,
            isDeclareISF: data.isDeclareISF,
            code: `${warehouse?.code}-${
              data.deliveryType === 1
                ? warehouse?.countryName
                : warehouse?.companyName
            }`,
            deliveryDemand: data.deliveryDemand,
            deliveryType: data.deliveryType,
            expressSupplier: data.expressSupplier
          }
          if (data.expressSupplier && data.deliveryType === 0) {
            const index = this.config.expressSupplierOptions.findIndex(
              (a) => a.value === data.expressSupplier,
            )
            this.kdSupplyIndex = index
          }
        }
      },
      deep: true
    }
  },
  async created() {
    try {
      const res = await getVesselNameList()
      if (res.success) {
        this.vesselNameOptions = res.data.map((a) => {
          return {
            value: a.vesselName,
            label: a.vesselName
          }
        })
      }
    } catch (error) {
      console.log(error)
    }
    this.getScinData()
    this.getImporterData()
  },
  async mounted() {
    // if (!this.companyDrapdown.length) {
    //   this.$store.dispatch('getCompanyDrapdown')
    // }
    if (!(this.addressDropOption && this.addressDropOption.length > 0)) {
      await this.$store.dispatch('getAddress')
    }
    if (!(this.addressBookOptions && this.addressBookOptions.length > 0)) {
      await this.$store.dispatch('getAddressBookOptions', {
        type: -1,
        companyId: 0
      })
    }
    if (!(this.shipTransportOptions && this.shipTransportOptions.length > 0)) {
      await this.$store.dispatch('getShipTransportOptions')
    }
    if (!(this.airTransportOptions && this.airTransportOptions.length > 0)) {
      await this.$store.dispatch('getAirTransportOptions')
    }
    if (!(this.shipOrginPortOptions && this.shipOrginPortOptions.length > 0)) {
      await this.$store.dispatch('getShipOrginPortOptions')
    }
    if (!(this.airOrginPortOptions && this.airOrginPortOptions.length > 0)) {
      await this.$store.dispatch('getAirOrginPortOptions')
    }
    if (
      !(this.shipDestinPortOptions && this.shipDestinPortOptions.length > 0)
    ) {
      await this.$store.dispatch('getShipDestinPortOptions')
    }
    if (!(this.airDestinPortOptions && this.airDestinPortOptions.length > 0)) {
      await this.$store.dispatch('getAirDestinPortOptions')
    }
    if (!(this.companyDrapdown && this.companyDrapdown.length > 0)) {
      await this.$store.dispatch('getCompanyDrapdown')
    }
    this.$refs.billInfo?.resetFields()
  },
 async activated() {
    this.getScinData()
    this.getImporterData()
     await this.$store.dispatch('getAddressBookOptions', {
        type: -1,
        companyId: 0
      })
  },
  methods: {
    changeShipper() {
      if (this.isSameShipper) {
        const item = this.manufacturerOptions.find(a => a.name === this.form1.shipperName)
        if (item) {
            this.form1.manufacturerName = this.form1.shipperName
            this.manufacturerNameChange()
        }
      }
    },
    changeConsignee() {
      if (this.isSameConsignee) {
         const item = this.importerList.find(a => a.name === this.form1.consigneeName)
          if (item) {
            this.form1.importerName = this.form1.consigneeName
          }
      }
      if (this.isSameConsigneeToUltimateConsignee) {
         const item = this.ultimateConsigneeOptions.find(a => a.name === this.form1.consigneeName)
          if (item) {
              this.form1.ultimateConsigneeName = this.form1.consigneeName
          }
      }
    },
    manufacturerNameChange() {
      const item = this.scinList.find(a => a.name === this.form1.manufacturerName)
      if (item) {
        this.form1.originCountry = this.addressDropCodeOption.find(a => a.id === item.countryId)?.value
      }
    },
    async getScinData() {
      try {
        const res = await getScinList()
        if (res.success) {
          this.scinList = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getImporterData() {
      try {
        const res = await getImporterDrapdown({ status: 4 })
        if (res.success) {
          this.importerList = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    onInput(type) {
      type === 'mblNo' &&
        this.$set(
          this.form1,
          'mblNo',
          this.form1.mblNo.replace(/[^A-Za-z0-9-]/g, '').toUpperCase(),
        )
      type === 'blNo' &&
        this.$set(
          this.form1,
          'blNo',
          this.form1.blNo.replace(/[^A-Za-z0-9-]/g, '').toUpperCase(),
        )
      type === 'routeLine' &&
        this.$set(
          this.form1,
          'routeLine',
          this.form1.routeLine.replace(/[^\da-zA-Z\+]/g, ''),
        )
      type === 'voyageNo' &&
        this.$set(
          this.form1,
          'voyageNo',
          this.form1.voyageNo.replace(/[^\da-zA-Z\-]/g, ''),
        )
      type === 'qty' &&
        this.$set(this.form1, 'qty', this.form1.qty.replace(/[^\d]/g, ''))
      type === 'weightCbm' &&
        this.$set(
          this.form1,
          'weightCbm',
          this.form1.weightCbm.replace(/[^\d.]/g, ''),
        )
      type === 'weightKgs' &&
        this.$set(
          this.form1,
          'weightKgs',
          this.form1.weightKgs.replace(/[^\d.]/g, ''),
        )
    },
    changeMblNo() {
      if (!this.form1.mblNo) {
        return false
      }
      if (this.billType && this.form1.mblNo[3] !== '-') {
        this.form1.mblNo = insertStr(this.form1.mblNo, 3, '-', true)
      }
      const str = this.billType
        ? this.form1.mblNo.slice(0, 3)
        : this.form1.mblNo.slice(0, 4)
      this.form1.code = str
      const item =
        str && this.transportOptions.find((a) => a.label.indexOf(str) > -1)
      if (item) {
        this.form1.transportName = item.label
      }
      // this.getStaging(this.form1.mblNo)
    },
    // 验证主单号
    checkMblNo: debounce(function(value, callback) {
      const param = {
        blNo: value,
        isExietsBlNO: true
      }
      existsMBL(param).then((res) => {
        if (res.success) {
          callback(new Error('提单号已存在，请重新输入'))
        } else {
          callback()
        }
      })
    }, 500),
    add(type) {
      this.warehouseType = type
      this.dialogVisible = true
    },
    async ok() {
      await this.$store.dispatch('getAddressBookOptions', { type: -1 })
      this.getScinData()
    this.getImporterData()
      this.dialogVisible = false
    },
    // async companyChange() {
    //   await this.$store.dispatch('getAddressBookOptions', {
    //     type: -1,
    //     // companyId: this.form1.companyId
    //   })
    // },
    save() {
      this.getData(1)
    },
    nextStep() {
      this.getData(0)
    },
    getData() {
      const billInfo = this.$refs.billInfo // 表单1
      const containerInfo = [] // 表单2 集合
      const billDetailInfo = this.$refs.billDetailInfo // 表单3
      !this.billType &&
        this.form2Data.forEach((a, i) => {
          containerInfo.push(this.$refs[`containerInfo${i}`][0])
        })
      let arr = []
      if (this.billType) {
        arr = [billInfo, billDetailInfo]
      } else {
        arr = [billInfo, ...containerInfo, billDetailInfo]
      }
      if (this.form3.clearenceType === 0 && this.form3.pickUpType === 0) {
        this.$message.error('禁止自清自提组合')
        return false
      }
      // 使用Promise.all去校验结果
      Promise.all(arr.map(this.getFormPromise)).then(async(res) => {
        const validateResult = res.every((item) => !!item)
        if (validateResult) {
          if (
            this.form1.mblNo.indexOf(this.form1.transportName.split('-')[0]) !==
            0
          ) {
            this.$message.warning(
              `提单号必须${this.billType ? '航空' : '船'}公司公司代码开头`,
            )
            return
          }
          if (this.form3.clearenceType && !this.isShowIsf && !this.billType && this.form3.isDeclareISF) {
            this.drawer = true
            return
          }
          // let consigneeNameBelong = 0
          // // 没有分单号则是直单
          // if (!this.form1.blNo) {
          //   const consigneeName = this.consigneeOptions.find(
          //     (a) => a.label === this.form1.consigneeName,
          //   ).id
          //   consigneeNameBelong =
          //     parseInt(consigneeName.companyId, 10) === 0
          //       ? 'Internal'
          //       : 'External'
          // }
          let warehouse
          if (this.form3.deliveryType) {
            warehouse = this.warehouseList.find(
              (a) => a.code === this.form3.code.split('-')[0],
            )
          }
          const detail = {
            // shipperName: this.form1.shipperName,
            // consigneeName: this.form1.consigneeName,
            // consigneeNameBelong: consigneeNameBelong,
            blNo: this.form1.blNo || this.form1.mblNo,
            weightKgs: this.form1.weightKgs,
            weightCbm: this.form1.weightCbm,
            clearence: {
              isf: this.isf?.onBoardDate ? this.isf : undefined,
              clearenceType: this.form3.clearenceType,
              isDeclareISF: this.form3.isDeclareISF,
              receivedDoEmail: this.form3.clearenceType
                ? this.form3.receivedDoEmail
                : undefined,
              receivedDoCompany: this.form3.clearenceType
                ? this.form3.receivedDoCompany
                : undefined
            },
            qty: this.form1.qty,
            clearanceMode: this.form3.clearanceMode,
            mblScinList: [{
              scin: this.consigneeOptions.find(a => a.name === this.form1.consigneeName),
              type: 1
            }, {
              scin: this.shipperOptions.find(a => a.name === this.form1.shipperName),
              type: 0
            }, {
              scin: this.notifyPartyOptions.find(a => a.name === this.form1.notifyPartyName),
              type: 3
            }, {
              scin: this.manufacturerOptions.find(a => a.name === this.form1.manufacturerName),
              type: 4
            }, {
              scin: this.ultimateConsigneeOptions.find(a => a.name === this.form1.ultimateConsigneeName),
              type: 5
            }, {
              importer: this.importerList.find(a => a.name === this.form1.importerName),
              type: 2
            }]
          }
          if (this.form3.pickUpType === 0) {
            // 自提
            detail.pickUp = {
              pickUpType: this.form3.pickUpType
            }
          } else if (this.form3.pickUpType === 1) {
            // 直送
            detail.pickUp = {
              pickUpType: this.form3.pickUpType,
              directDelivery: {
                deliveryType: this.form3.deliveryType,
                wareHouse: this.form3.code
                  ? {
                      code: this.form3.code,
                      ...warehouse
                    }
                  : undefined,
                express:
                  this.form3.deliveryType === 0
                    ? {
                        expressSupplier:
                          this.config.expressSupplierOptions[this.kdSupplyIndex]
                            ?.value
                      }
                    : undefined
              }
            }
          } else {
            detail.pickUp = {
              pickUpType: this.form3.pickUpType
            }
          }
          const params = {
            companyId: this.form1.companyId,
            type: this.billType,
            mblNo: this.form1.mblNo,
            transportName: this.form1.transportName,
            classification: this.form1.blNo
              ? this.form1.blNo === this.form1.mblNo
                ? 0
                : 1
              : 0,
            etd: this.form1.date[0],
            eta: this.form1.date[1],
            countryCode: this.form1.countryCode,
            originCountry: this.form1.originCountry,
            originHarborName: this.form1.originHarborName,
            destinationHarborName: this.form1.destinationHarborName,
            dischargeHarbor: this.form1.dischargeHarbor,
            dischargeHarborDate: this.form1.dischargeHarborDate,
            containers: !this.billType ? this.form2Data : undefined,
            detail
          }
          try {
            console.log('创建MBL参数:', params)
            const res = await createMbl(params)
            if (res.success) {
              this.$message.success('创建成功')
              this.resetFields()
              this.isf = null
              console.log(res)
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.log(error)
          }
        } else {
          this.$message.error('请将信息填写完整')
        }
      })
    },
    resetFields() {
      this.$refs.billInfo?.resetFields()
      this.form2Data = [
        {
          containerNumber: '',
          containertype: '20GP',
          sealNumber: '',
          routeLine: '',
          voyageNo: '',
          vesselName: ''
        }
      ]
      this.form3 = {
        clearenceType: 1,
        pickUpType: 0,
        deliveryType: 1,
        code: '',
        deliveryDemand: '',
        expressSupplier: '',
        isDeclareISF: 1
      }
      this.$refs.billDetailInfo?.resetFields()
      this.fileList = []
      this.mblFile = null
      this.isShowIsf = false
    },
    getFormPromise(form) {
      return new Promise((resolve) => {
        form.validate((res) => {
          resolve(res)
        })
      })
    },
    onTypeBlur(e) {
      if (e.target.value) {
        const item = this.vesselNameOptions.find(
          (a) => a.label === e.target.value,
        )
        if (!item) {
          this.form1.vesselName = e.target.value
        }
      }
    },
    deleteCabinet(index) {
      this.form2Data.splice(index, 1)
    },
    addCabinet() {
      const obj = {
        containerNumber: '',
        containertype: '20GP',
        sealNumber: '',
        qty: '',
        weightCbm: '',
        weightKgs: ''
      }
      this.form2Data.push({ ...obj })
    },
    tabChange(item, type) {
      !type && (this.form3.clearenceType = item.id)
      type && (this.form3.pickUpType = item.id)
    },
    ok1(isf) {
      this.isf = isf
      this.drawer = false
      this.isShowIsf = true
    },
    async ok2(data) {
      await this.$store.dispatch('getAddressBookOptions', {
        type: -1
        // companyId: data.form1.companyId
      })
      this.form1 = data.form1
      this.form2Data = data.form2Data
      this.form3 = data.form3
      this.dialogVisible1 = false
    },
    download() {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      const guid = 'x6pkh4ex5off49ftl7v38p37cbu2o87x'
      elink.href = `/api/SystemFile/downLoadTemplate?guid=${guid}`
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    }
  }
}
</script>

<style lang="less" scoped>
.step-contanier {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
  &:deep(.el-form-item__content) {
    line-height: 30px;
  }
  .view {
    width: 100%;
    height: calc(100% - 90px);
    overflow-x: auto;
    overflow-y: auto;
    .bill-detail {
      display: flex;
    }
    .content {
      width: 100%;
      height: auto;
      border-radius: 6px;
      padding: 8px 0 0;
      box-sizing: border-box;
      .cabinet-item {
        position: relative;
        width: 1562px;
        height: auto;
        background: #f8fbff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid rgb(18, 88, 188);
        box-sizing: border-box;
        padding: 20px;
        .delete-cabinet {
          position: absolute;
          right: -1px;
          top: -1px;
          cursor: pointer;
        }
        .el-form {
          display: flex;
        }
        /deep/ .el-form-item {
          margin-bottom: 0;
        }
        & + .cabinet-item {
          margin-top: 10px;
        }
      }
      .suffix {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        margin-right: 10px;
      }
      .upload-demo {
        width: 600px;
        height: 340px;
        background: #f8fbff;
        border-radius: 6px 6px 6px 6px;
        .el-icon-upload {
          width: 80px;
          height: 80px;
        }
        &:deep(.el-upload) {
          width: 100%;
          height: 100%;
        }
        &:deep(.el-upload-dragger .el-icon-upload) {
          margin-top: 60px;
        }
        &:deep(.el-upload-dragger) {
          width: 100%;
          height: 100%;
          background: #f8fbff;
        }
        .upload {
          width: 120px;
          height: 40px;
          margin-top: 16px;
          border-color: rgb(18, 88, 188);
          color: rgb(18, 88, 188);
        }
      }
      .fileLists {
        width: 552px;
        height: 40px;
        padding: 12px 24px;
        background: #ffffff;
        box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.1);
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        margin: 16px 0 16px;
        display: flex;
        justify-content: space-between;
        .icon {
          color: #b8c3de;
          line-height: 40px;
          font-size: 24px;
          cursor: pointer;
        }
        .file {
          display: flex;
        }
        .des {
          margin-left: 16px;
        }
        .fileName {
          width: auto;
          height: 19px;
          font-size: 14px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #25396f;
          line-height: 19px;
        }
        .fileSize {
          width: auto;
          margin-top: 5px;
          height: 16px;
          font-size: 12px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #7c8db5;
          line-height: 16px;
        }
      }
    }
    .row {
      display: flex;
      .transportName {
        margin-left: 20px;
        line-height: 40px;
        font-size: 18px;
        color: rgb(18, 88, 188);
      }
      &:deep(.el-form-item) {
        position: relative;
      }
      .customSelect {
        width: 100%;
      }
      .field {
        width: auto;
        height: 40px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #606266;
        line-height: 40px;
      }
      .require {
        color: rgba(255, 116, 68, 1);
      }
      .supplyList {
        width: 100%;
        height: 40px;
        display: flex;
        .item {
          width: 160px;
          height: 38px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 1px solid #dbe4f2;
          text-align: center;
          position: relative;
          cursor: pointer;
          & + .item {
            margin-left: 16px;
          }
          .logoUrl {
            max-width: 160px;
            max-height: 36px;
            padding-top: 1px;
          }
        }
        .active {
          border: 1px solid rgb(18, 88, 188);
          &::before {
            content: " ";
            width: 0;
            height: 0;
            background: transparent;
            border-top: 13px solid rgb(18, 88, 188);
            border-right: 13px solid rgb(18, 88, 188);
            border-bottom: 13px solid transparent;
            border-left: 13px solid transparent;
            opacity: 1;
            position: absolute;
            top: -1px;
            left: 134px;
            z-index: 1;
          }
          &::after {
            content: " ";
            width: 15px;
            height: 9px;
            background-image: url("~@/assets/images/gou.png");
            background-repeat: no-repeat;
            background-size: 75%;
            position: absolute;
            top: 2px;
            left: 147px;
            z-index: 2;
          }
        }
      }
    }
    &:deep(.el-form-item) {
      & + .el-form-item {
        margin-left: 30px;
      }
      .el-form-item__label {
        display: flex;
      }
      .form-item_label {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
      }
      .add {
        margin-left: 16px;
        cursor: pointer;
        color: #1258bc;
        width: auto;
        padding: 0 14px;
        border: 1px solid #1258bc;
        height: 24px;
        line-height: 24px;
        border-radius: 4px;
        display: inline-block;
        .icon {
          font-size: 20px;
          margin-right: 4px;
          vertical-align: text-top;
        }
      }
    }
    .panel-opt {
      display: flex;
      align-items: center;
      margin-left: 10px;
      .cabinet-opt-item {
        display: flex;
        align-items: center;
        width: auto;
        height: 40px;
        border-radius: 6px 4px 4px 4px;
        border: 1px solid rgb(18, 88, 188);
        box-sizing: border-box;
        background-image: url("~@/assets/images/bill/cabinet-bg.png");
        background-repeat: no-repeat;
        & > span {
          display: flex;
          align-items: center;
          height: 100%;
          box-sizing: border-box;
        }
        & > span:nth-child(1) {
          width: 83px;
          padding-left: 15px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: bold;
          font-size: 14px;
          color: #ffffff;
        }
        & > span:nth-child(2) {
          width: auto;
          padding-right: 10px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: bold;
          font-size: 14px;
          color: rgb(18, 88, 188);
        }
      }
      & > div + div {
        margin-left: 15px;
      }
      .add {
        width: 116px;
        height: 39px;
        background: rgb(18, 88, 188);
        border-radius: 18px 18px 18px 18px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
        .icon {
          font-size: 20px;
          margin-right: 4px;
        }
      }
    }
  }
  .pageBtn {
    width: 100%;
    height: 80px;
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
    border-radius: 0px 0px 6px 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    position: absolute;
    .btn {
      width: 160px;
      height: 40px;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      font-size: 14px;
      font-weight: 400;
      box-sizing: border-box;
      cursor: pointer;
      & + .btn {
        margin-left: 16px;
      }
    }
    .btn-defalut {
      border: 1px solid rgb(18, 88, 188);
      color: rgb(18, 88, 188);
    }
    .btn-primary {
      background: rgb(18, 88, 188);
      color: #ffffff;
    }
    .download {
      position: absolute;
      left: 10px;
      top: 20px;
      width: 140px;
      height: 40px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      border: 1px solid #dbe4f2;
      font-size: 14px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #7c8db5;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      img {
        vertical-align: -4px;
      }
      & + .download {
        left: 192px;
      }
    }
  }
}
.catch-btn {
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  background-color: rgb(18, 88, 188);
  border: 1px solid rgb(18, 88, 188);
  box-sizing: border-box;
  border-radius: 4px;
  color: #fff;
}
</style>
